import { checkHttpStatus, parseJSON } from '@utils/response';
import i18next from 'i18next';
import * as LoginCode from '@scripts/StatusLoginCode';
import * as StatusCode from '@scripts/StatusCode';
import jwt from 'jwt-decode';
import { getDefaultParam, getDefaultParamPE } from '@actions/param';
import 'whatwg-fetch';
import * as storage from '@utils/storage'
import { IsEnglish } from '@utils/language';
import { encryptPassword } from '@utils';
import { encryption } from '@utils/encryption';
import { getIP } from '@utils/index';
import { listMenu } from '@actions/configMenu';
import { listMenuSupervisor } from '@actionsSup/configMenu';
import { noMenuRedirect, home } from '@utils/redirect';
import * as AccessTypeMode from '@scripts/AccessTypeMode';
import { IsEmployeeMode, IsSupervisorMode } from '@users';
import * as cookie from '@scripts/CookiesAppGo';
import Cookies from 'js-cookie';
import { stringToBoolean } from '@utils';
import { getDeviceInfo } from '../../utils/deviceInfo';

export function renewTokenSuccess(token) {
    storage.saveToken(token);

    const userData = jwt(token);
    storage.saveSessionGuid(userData.SessionGuid);
}


// Do not remove isSourceLogin and let it always in last
export function loginUserSuccess(token, acceptedTermsUse, termsUse, legalInfo, showDateStatementTerms,
    showDateStatementLegalInfo, scheduleReturnDate, useGeolocation, useGeolocationZone, creditCardSupport,
    punchTime, colorCalendar, useWorkInstructions, isDisplayMedicalData, isDisplayDistributionSlip,
    isDisplayPreferenceCommunication, isCCQ, isPartialRequestHoursUsed, taxationProvince,
    isMandatoryPhoneCellPerso, isMandatoryEmailPerso, isMandatorySMSPerso, communicationPreference, userName,
    isDisplayPayAdvanceVacation, isUsePartialRequest, isDisplayPayablesHours, isUseMaterialResourceTimesheet,
    notificationPublicKey, isNotificationActivate, isDisplayFlagFullTime, isProfileConsultationMode, isDisplayBankOthers,
    isDisplayBankVacation, useServiceProvider, useGeolocationMandatory, worksites, isOnCallFlag, isUseCCQStatus,
    isUseCCQTask, isDisplayChatMenu, isDisplayExpenseAccountClassif, useAttendanceConfirmation,
    isDisplaySeniorityDate, isDisplayInactiveDate, isDisplayHiringDate, isDisplayFirstDate, isDisplayLastDate,
    isDisplayEmergencyContacts, isDisplayCCQClassifications, isDisplayLastDevices, isDisplayBankBalances, canEmployeeChangePhoto, displayBankingInformation,
    useFilePunch, useDailyReport, useEventReport,
    isSourceLogin = true) {
    storage.saveToken(token);
    storage.saveAcceptedTermsUse(acceptedTermsUse);
    storage.saveTermsUse(termsUse);
    storage.saveLegalInfo(legalInfo);
    storage.saveShowDateStatementTerms(showDateStatementTerms);
    storage.saveShowDateStatementLegalInfo(showDateStatementLegalInfo);
    storage.saveScheduleReturnDate(scheduleReturnDate);
    storage.saveUseGeolocation(useGeolocation);
    storage.saveUseGeolocationZone(useGeolocationZone);
    storage.saveCreditCardSupport(creditCardSupport);
    storage.savePunchTime(punchTime);
    storage.saveColorCalendar(colorCalendar);
    storage.saveUseWorkInstructions(useWorkInstructions);
    storage.saveDisplayMedicalData(isDisplayMedicalData);
    storage.saveDisplayDistributionSlip(isDisplayDistributionSlip);
    storage.saveDisplayPreferenceCommunication(isDisplayPreferenceCommunication);
    storage.saveDisplaySeniorityDate(isDisplaySeniorityDate);
    storage.saveDisplayInactiveDate(isDisplayInactiveDate);
    storage.saveDisplayHiringDate(isDisplayHiringDate);
    storage.saveDisplayFirstDate(isDisplayFirstDate);
    storage.saveDisplayLastDate(isDisplayLastDate);
    storage.saveDisplayEmergencyContacts(isDisplayEmergencyContacts);
    storage.saveDisplayCCQClassifications(isDisplayCCQClassifications);
    storage.saveDisplayLastDevices(isDisplayLastDevices);
    storage.saveDisplayBankBalances(isDisplayBankBalances);
    storage.saveCanEmployeeChangePhoto(canEmployeeChangePhoto);
    storage.saveDisplayBankingInformation(displayBankingInformation);
    storage.saveIsCCQ(isCCQ);
    storage.savePartialRequestHoursUsed(isPartialRequestHoursUsed);
    storage.saveTaxationProvince(taxationProvince);
    storage.saveIsMandatoryPhoneCellPerso(isMandatoryPhoneCellPerso);
    storage.saveIsMandatoryEmailPerso(isMandatoryEmailPerso);
    storage.saveIsMandatorySMSPerso(isMandatorySMSPerso);
    storage.saveCommunicationPreference(communicationPreference);
    storage.saveUserName(userName);
    storage.saveIsDisplayPayAdvanceVacation(isDisplayPayAdvanceVacation);
    storage.saveIsUsePartialRequest(isUsePartialRequest);
    storage.saveIsDisplayPayablesHours(isDisplayPayablesHours);
    storage.saveIsUseMaterialResourceTimesheet(isUseMaterialResourceTimesheet);
    storage.saveNotificationPublicKey(notificationPublicKey);
    storage.saveIsNotificationActivate(isNotificationActivate);
    storage.saveDisplayFlagFullTime(isDisplayFlagFullTime);
    storage.saveIsProfileConsultationMode(isProfileConsultationMode);
    storage.saveIsDisplayBankOthers(isDisplayBankOthers);
    storage.saveIsDisplayBankVacation(isDisplayBankVacation);
    storage.saveUseServiceProvider(useServiceProvider);
    storage.saveUseGeolocationMandatory(useGeolocationMandatory);
    storage.saveWorksites(worksites);
    storage.saveIsOnCallFlag(isOnCallFlag);
    storage.saveIsUseCCQStatus(isUseCCQStatus);
    storage.saveIsUseCCQTask(isUseCCQTask);
    storage.saveIsDisplayChatMenu(isDisplayChatMenu);
    storage.saveIsDisplayExpenseAccountClassif(isDisplayExpenseAccountClassif);
    storage.saveUseAttendanceConfirmation(useAttendanceConfirmation);
    storage.saveUseFilePunch(useFilePunch);
    storage.saveUseDailyReport(useDailyReport);
    storage.saveUseEventReport(useEventReport);

    const userData = jwt(token);
    storage.saveSessionGuid(userData.SessionGuid);

    getDefaultParam().then((response) => {
        if (typeof response == 'undefined') return;

        const paramData = JSON.parse(response.list);

        if (paramData !== undefined) {
            storage.saveGoogleApiKey(paramData.mapsApiKey);
            storage.saveStartDayTimesheet(paramData.startDayTimesheet);
            storage.saveAbcUsage(paramData.useABC);
            storage.saveLinkProjectPActivity(paramData.linkProjectPActivity);
        }
    });

    getDefaultParamPE().then((response) => {
        if (typeof response == 'undefined') return;

        const paramData = JSON.parse(response.list);
        if (paramData !== undefined) {
            storage.saveUseTimeTimesheet(paramData.useTimeTimesheet);
            storage.saveUseTimeTimesheetRequired(paramData.useTimeTimesheetRequired);
        }
    });

    storage.saveHasEmpAccess(stringToBoolean(userData.HasEmpAccess));
    storage.saveHasSupAccess(stringToBoolean(userData.HasSupAccess));

    Cookies.set(cookie.last_access_type, encryption(AccessTypeMode.Employee), { expires: 90 });
    Cookies.set(cookie.last_cmp, encryption(userData.Company), { expires: 90 });
    Cookies.set(cookie.last_ws, '', { expires: 90 });
}

// Do not remove isSourceLogin and let it always in last
export function loginUserSupervisorSuccess(token, acceptedTermsUse, termsUse, legalInfo, showDateStatementTerms,
    showDateStatementLegalInfo, userName, notificationPublicKey, isNotificationActivate, worksites,
    isSourceLogin = true) {

    storage.saveToken(token);
    storage.saveAcceptedTermsUse(acceptedTermsUse);
    storage.saveTermsUse(termsUse);
    storage.saveLegalInfo(legalInfo);
    storage.saveShowDateStatementTerms(showDateStatementTerms);
    storage.saveShowDateStatementLegalInfo(showDateStatementLegalInfo);
    storage.saveUserName(userName);
    storage.saveNotificationPublicKey(notificationPublicKey);
    storage.saveIsNotificationActivate(isNotificationActivate);
    storage.saveWorksites(worksites);

    const userData = jwt(token);
    const worksite = worksites.filter(x => x.worksite == userData.Worksite && x.company == userData.Company)[0];

    storage.saveIsUseWorkorderInPunch(worksite.isUseWorkorderInPunch);
    storage.saveIsProjectEntry(worksite.isProjectEntry);
    storage.saveIsActivityEntry(worksite.isActivityEntry);
    storage.saveIsTaskEntry(worksite.isTaskEntry);
    storage.saveIsUseAbc(worksite.isUseAbc);
    storage.saveIsUseActivityRemark(worksite.isUseActivityRemark);
    storage.saveIsBlockAssocWorkorderInPunch(worksite.isBlockAssocWorkorderInPunch);
    storage.saveUseOtherClassification(worksite.useOtherClassification);
    storage.saveIsUseOrderFormReq(worksite.isUseOrderFormReq);
    storage.saveUseRequisitionCodeOnPunch(worksite.useRequisitionCodeOnPunch);
    storage.saveUsePersonnelRequisitionMileage(worksite.usePersonnelRequisitionMileage);
    storage.saveVacColor(worksite.vacColor);
    storage.saveHolidayColor(worksite.holidayColor);
    storage.saveOffColor(worksite.offColor);
    storage.savePshColor(worksite.pshColor);
    storage.saveAbsColor(worksite.absColor);
    
    storage.saveSessionGuid(userData.SessionGuid);
    storage.saveHasEmpAccess(stringToBoolean(userData.HasEmpAccess));
    storage.saveHasSupAccess(stringToBoolean(userData.HasSupAccess));
    
    const sessionSup = JSON.parse(userData.SessionSup);
    storage.saveUseDoubleApprobation(sessionSup.UseDoubleApprobation);
    storage.saveApprobationStructure(sessionSup.ApprobationStructure);
    storage.saveIsLevel2Approbator(sessionSup.Lv2Approver);
    storage.saveIsApprobationLv1Mandatory(sessionSup.ApprobationLv1BeforeLv2Mandatory);
    storage.saveIsSuperUser(sessionSup.IsSuperUser);
    storage.saveAllowConsultation(sessionSup.AllowConsultation);
    storage.saveScheduleReturnDate(sessionSup.IsUseScheduleReturnDate);
    storage.saveIsUsePartialRequest(sessionSup.IsUsePartialRequest);
    storage.saveIsRefusalRequestMandatoryComment(sessionSup.IsRefusalRequestMandatoryComment);
    storage.saveAllowApprobation(sessionSup.AllowApprobation);
    storage.saveCommentForApprovOnPunch(sessionSup.CommentForApprovOnPunch);
    storage.saveIsPayProjectWithSkills(sessionSup.IsPayProjectWithSkills);
    storage.saveIsActivityAssocWorkorderInPunch(sessionSup.IsActivityAssocWorkorderInPunch);
    storage.saveIsDisplayJobTitleProfileByDepartment(sessionSup.IsDisplayJobTitleProfileByDepartment);
    storage.saveIsDisplayPayProjectProfileByDepartment(sessionSup.IsDisplayPayProjectProfileByDepartment);
    storage.saveIsDisplayShiftProfileByProject(sessionSup.IsDisplayShiftProfileByProject);
    storage.saveIsUseBankExtraTime(sessionSup.IsUseBankExtraTime);
    storage.saveIsUseExtraTimePay(sessionSup.IsUseExtraTimePay);
    storage.saveIsDisplaySubcodeProfileByDepartment(sessionSup.IsDisplaySubcodeProfileByDepartment);
    storage.saveIsDisplaySubcodeProfileByJobTitle(sessionSup.IsDisplaySubcodeProfileByJobTitle);
    storage.saveIsDisplaySubcodeProfileByProject(sessionSup.IsDisplaySubcodeProfileByProject);
    storage.saveHasEmploymentStatusOnShift(sessionSup.HasEmploymentStatusOnShift);
    storage.saveDefaultSubcodTransacWithExtraTimeBank(sessionSup.DefaultSubcodTransacWithExtraTimeBank);
    storage.saveDefaultSubcodTransacWithExtraTimePay(sessionSup.DefaultSubcodTransacWithExtraTimePay);
    storage.saveDefaultABCProjectHoliday(sessionSup.DefaultABCProjectHoliday);
    storage.saveDefaultABCActivityHoliday(sessionSup.DefaultABCActivityHoliday);
    storage.saveDefaultPayProjectHoliday(sessionSup.DefaultPayProjectHoliday);
    storage.saveDefaultPayActivityHoliday(sessionSup.DefaultPayActivityHoliday);
    storage.saveDefaultPayTaskHoliday(sessionSup.DefaultPayTaskHoliday);
    storage.saveDefaultABCProjectHolidayCrypt(sessionSup.DefaultABCProjectHolidayCrypt);
    storage.saveDefaultABCActivityHolidayCrypt(sessionSup.DefaultABCActivityHolidayCrypt);
    storage.saveIsDepartmentMandatoryOnProject(sessionSup.IsDepartmentMandatoryOnProject);
    storage.saveDefaultWorkOrder(sessionSup.DefaultWorkOrder);
    storage.saveIsLinkProjectActivityTaskP(sessionSup.IsLinkProjectActivityTaskP);
    storage.saveIsProjAssocWorkorderInPunch(sessionSup.IsProjAssocWorkorderInPunch);
    storage.saveIsDefaultApprovManEntryApprovalPortal(sessionSup.IsDefaultApprovManEntryApprovalPortal);
    storage.saveIsJobTitleEntry(sessionSup.IsJobTitleEntry);
    storage.saveIsPayProjectLoadedFromWorkorder(sessionSup.IsPayProjectLoadedFromWorkorder);
    storage.saveIsUseWorkorder(sessionSup.IsUseWorkorder);
    storage.saveIsWorkOrderLinkedToDepartment(sessionSup.IsWorkOrderLinkedToDepartment);
    
    Cookies.set(cookie.last_access_type, encryption(AccessTypeMode.Supervisor), { expires: 90 });
    Cookies.set(cookie.last_cmp, encryption(userData.Company), { expires: 90 });
    Cookies.set(cookie.last_ws, encryption(userData.Worksite), { expires: 90 });
}

export function loginFirstSetup(employeeId, userCode, isPasswordComplex, minLengthPassword, clientHashKey) {
    storage.saveEmployeeId(employeeId);
    storage.saveUserCode(userCode);
    storage.saveIsPasswordComplex(isPasswordComplex);
    storage.saveMinLengthPassword(minLengthPassword);
    storage.saveClientHashKey(clientHashKey);
}

export function loginUserFailure(error) {
    storage.destroyToken();
    storage.destroySessionGuid();
}

export function sessionLogout() {
    storage.destroyToken();
    storage.destroySessionGuid();
}

export function logoutAndRedirect() {
    sessionLogout();
}

export async function loginUser(userCode, password, connection, isPrefixDB) {
    const devInfo = await encodeURIComponent(JSON.stringify(await getDeviceInfo()));
    return fetch('authentication/login', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            UserCode: userCode,
            Password: encryptPassword(password),
            Conn: connection,
            IsPrefixDB: isPrefixDB,
            LastTypeMode: Cookies.get(cookie.last_access_type),
            LastCompany: Cookies.get(cookie.last_cmp),
            LastWorksite: Cookies.get(cookie.last_ws),
            DeviceInfo: devInfo
        })
    })
        .then(checkHttpStatus)
        .then(parseJSON)
        .then(response => {
            return handleLoginResponse(response);
        })
        .catch(error => {
            loginUserFailure(error);
        })
}

export async function loginUserSSO(userCode, connection) {
    const ip = await getIP();
    const devInfo = await encodeURIComponent(JSON.stringify(await getDeviceInfo()));

    return fetch('authentication/loginSSO', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCode: encryption(userCode),
            ipAddress: ip,
            conn: connection,
            LastTypeMode: Cookies.get(cookie.last_access_type),
            LastCompany: Cookies.get(cookie.last_cmp),
            LastWorksite: Cookies.get(cookie.last_ws),
            DeviceInfo: devInfo
        })
    })
        .then(checkHttpStatus)
        .then(parseJSON)
        .then(response => {
            return handleLoginResponse(response);
        })
        .catch(error => {
            loginUserFailure(error);
        })
}

const handleLoginResponse = (response) => {
    try {
        const result = { statusLogin: -1, errorMessage: '', compagnies: [] };

        if (response.status === StatusCode.STATUS_UNAUTHORIZED) {
            result.statusLogin = LoginCode.LOGIN_FAILED;
            result.errorMessage = i18next.t('login:login.message.failed');
            return result;
        }

        let message = '';

        if (response.statusLogin === LoginCode.LOGIN_SUCCESSFULL) {
            // If the user has only one company so we save the data,
            // otherwise he will have to choose wich company he wants to access
            if (response.isOneStepLogin) {
                const userData = jwt(response.token);

                if (userData.AccessType == AccessTypeMode.Employee) {
                    // Save user data
                    const dataCompany = response.companies[0];

                    loginUserSuccess(response.token, response.isTermsValid,
                        IsEnglish() ? response.termsEn : response.termsFr,
                        IsEnglish() ? response.legalInfoEn : response.legalInfoFr,
                        response.showDateStatementTerms,
                        response.showDateStatementLegalInfo,
                        dataCompany.scheduleReturnDate,
                        dataCompany.useGeolocation,
                        dataCompany.useGeolocationZone,
                        dataCompany.creditCardSupport,
                        dataCompany.punchByTime,
                        dataCompany.colorCalendar,
                        dataCompany.useWorkInstructions,
                        dataCompany.isDisplayMedicalData,
                        dataCompany.isDisplayDistributionSlip,
                        dataCompany.isDisplayPreferenceCommunication,
                        dataCompany.isCCQ,
                        dataCompany.isPartialRequestHoursUsed,
                        dataCompany.taxationProvince,
                        dataCompany.isMandatoryPhoneCellPerso,
                        dataCompany.isMandatoryEmailPerso,
                        dataCompany.isMandatorySMSPerso,
                        dataCompany.communicationPreference,
                        response.userName,
                        dataCompany.isDisplayPayAdvanceVacation,
                        dataCompany.isUsePartialRequest,
                        dataCompany.isDisplayPayablesHours,
                        dataCompany.isUseMaterialResourceTimesheet,
                        response.notificationPublicKey,
                        response.isNotificationActivate,
                        dataCompany.isDisplayFlagFullTime,
                        dataCompany.isProfileConsultationMode,
                        dataCompany.isDisplayBankOthers,
                        dataCompany.isDisplayBankVacation,
                        dataCompany.useServiceProvider,
                        dataCompany.useGeolocationMandatory,
                        response.worksites,
                        response.isOnCallFlag,
                        dataCompany.isUseCCQStatus,
                        dataCompany.isUseCCQTask,
                        dataCompany.isDisplayChatMenu,
                        dataCompany.isDisplayExpenseAccountClassif,
                        dataCompany.useAttendanceConfirmation,
                        dataCompany.isDisplaySeniorityDate,
                        dataCompany.isDisplayInactiveDate,
                        dataCompany.isDisplayHiringDate,
                        dataCompany.isDisplayFirstDate,
                        dataCompany.isDisplayLastDate,
                        dataCompany.isDisplayEmergencyContacts,
                        dataCompany.isDisplayCCQClassifications,
                        dataCompany.isDisplayLastDevices,
                        dataCompany.isDisplayBankBalances,
                        dataCompany.canEmployeeChangePhoto,
                        dataCompany.displayBankingInformation,
                        dataCompany.useFilePunch,
                        dataCompany.useDailyReport,
                        dataCompany.useEventReport,
                    );
                }

                if (userData.AccessType == AccessTypeMode.Supervisor) { //TODO : manage isDisplayChatMenu to activate / deactivate chat Menu for Supervisor AccessTypeMode                    
                    loginUserSupervisorSuccess(
                        response.token,
                        response.isTermsValid,
                        IsEnglish() ? response.termsEn : response.termsFr,
                        IsEnglish() ? response.legalInfoEn : response.legalInfoFr,
                        response.showDateStatementTerms,
                        response.showDateStatementLegalInfo,
                        response.userName,
                        response.notificationPublicKey,
                        response.isNotificationActivate,
                        response.worksites,
                    );
                }
            } else {
                // Login step 2
                storage.saveToken(response.token);
                const userData = jwt(response.token);
                storage.saveSessionGuid(userData.SessionGuid);
                response.statusLogin = LoginCode.LOGIN_STEP2
                if (IsEmployeeMode()) {
                    result.companies = response.companies;
                } else if (IsSupervisorMode()) {
                    result.worksites = response.worksites;
                } else {
                    message = i18next.t('error:generic-error');
                }
            }
            // Redirect Home
        } else if (response.statusLogin === LoginCode.LOGIN_USERLOCKED) {
            message = i18next.t('login:login.message.locked');
        } else if (response.statusLogin === LoginCode.LOGIN_PASSWORDFIRSTSETUP) {
            loginFirstSetup(response.employeeId, response.userCode, response.isPasswordComplex, response.minLengthPassword, response.clientHashKey);
            message = i18next.t('login:login.message.passwordFirstSetup');
        } else if (response.statusLogin === LoginCode.LOGIN_CHANGEPASSWORD) {
            message = i18next.t('login:login.message.changePassword');
        } else if (response.statusLogin === LoginCode.LOGIN_RESTRICTEDEMPLOYEEHIRED) {
            message = i18next.t('login:login.message.restrictedEmployeeHired');
        } else if (response.statusLogin === LoginCode.LOGIN_TEMPORARILYUNAVAILABLE) {
            message = i18next.t('login:login.message.temporarilyUnavailable');
        } else if (response.statusLogin === LoginCode.LOGIN_INACTIVEPORTAL) {
            message = i18next.t('login:login.message.inactivePortal');
        } else if (response.statusLogin === LoginCode.LOGIN_EMAILNOTPERMITTED) {
            message = i18next.t('login:login.message.emailNotPermitted');
        }

        result.statusLogin = response.statusLogin;
        result.errorMessage = message;

        return result;
    } catch (e) {
        loginUserFailure({
            response: {
                status: 403,
                statusText: 'Invalid token'
            }
        });
    }
}

export async function connectApp(props, isAuthSSO = false) {
    // Load menu parameters and data
    let response;

    if (IsEmployeeMode()) {
        response = await listMenu();
    }

    if (IsSupervisorMode()) {
        response = await listMenuSupervisor();
    }

    if (response != null && response.status == StatusCode.STATUS_OK) {
        // Success
        const result = JSON.parse(response.menu);
        storage.saveIsDisplayChatMenu(result.isDisplayChatMenu);
        storage.saveMenu(result.list);
        storage.saveFavouritesMenus(result.listFav);
        storage.saveIsAuthSSO(isAuthSSO);

        saveCookieLogin(props);
        home();
    } else {
        storage.destroyMenu();
        noMenuRedirect();
    }

    //return response != null && response.status == StatusCode.STATUS_OK;
}

const saveCookieLogin = (props) => {
    const { cookies } = props;
    // Here we save the datetime that the user login successfully
    cookies.set(cookie.login, new Date().toLocaleString(), { path: '/' });
}